import { render } from "./BankLoanDetailsView.vue?vue&type=template&id=333effde&scoped=true"
import script from "./BankLoanDetailsView.vue?vue&type=script&lang=js"
export * from "./BankLoanDetailsView.vue?vue&type=script&lang=js"

import "./BankLoanDetailsView.vue?vue&type=style&index=0&id=333effde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333effde"]])

export default __exports__